/**
 * Installs `Object.hasOwn` (ES2022, Safari 15.4+) when the browser lacks it.
 *
 * es-toolkit's compat modules — pulled in transitively by `@inertiajs/core` —
 * call `Object.hasOwn` at runtime, which throws an unhandled TypeError on
 * iOS < 15.4 (Sentry DUESY-3N4). No-op when the native implementation exists.
 */
export function installObjectHasOwnPolyfill(): void {
    if (typeof Object.hasOwn === 'function') {
        return
    }

    Object.defineProperty(Object, 'hasOwn', {
        value: (obj: object, key: PropertyKey): boolean =>
            Object.prototype.hasOwnProperty.call(Object(obj), key),
        writable: true,
        configurable: true,
        enumerable: false,
    })
}

installObjectHasOwnPolyfill()
